module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.c3982522.jpg";